interface RankItem {
  rank: number;
  title: string;
  tag: string;
  heat: string;
  category: string;
}

const rankingData: RankItem[] = [
  { rank: 1, title: '某顶流男星深夜密会神秘女子，酒店同框照曝光', tag: '爆', heat: '982万', category: '娱乐圈' },
  { rank: 2, title: '热门综艺录制现场突发冲突，导演组紧急叫停', tag: '热', heat: '876万', category: '综艺' },
  { rank: 3, title: '知名网红直播间带货翻车，品牌方连夜发声明', tag: '热', heat: '754万', category: '网红' },
  { rank: 4, title: '某影视剧组被曝拖欠群演工资，引发行业关注', tag: '新', heat: '632万', category: '影视' },
  { rank: 5, title: '一线女星社交平台小号被扒，内容引发粉丝热议', tag: '新', heat: '521万', category: '娱乐圈' },
  { rank: 6, title: '某品牌代言人突然解约，背后原因耐人寻味', tag: '', heat: '489万', category: '商业' },
  { rank: 7, title: '热门电视剧大结局删减片段流出，网友炸锅', tag: '热', heat: '415万', category: '影视' },
];

function getRankColor(rank: number): string {
  if (rank === 1) return 'bg-primary-500 text-background-50';
  if (rank === 2) return 'bg-accent-500 text-background-50';
  if (rank === 3) return 'bg-secondary-500 text-background-50';
  return 'bg-background-200 text-foreground-600';
}

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热搜榜单
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            实时追踪全网最火吃瓜事件，热度排行一目了然
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-2">
          {rankingData.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-3 md:gap-4 p-3 md:p-4 bg-background-50 rounded-xl border border-background-200/60 hover:border-accent-300/50 transition-colors cursor-pointer group"
            >
              <span
                className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold flex-shrink-0 ${getRankColor(item.rank)}`}
              >
                {item.rank}
              </span>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-medium text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center gap-2 mt-1">
                  <span className="text-xs text-foreground-500 bg-background-100 px-1.5 py-0.5 rounded">
                    {item.category}
                  </span>
                </div>
              </div>
              {item.tag && (
                <span className={`text-xs font-bold px-2 py-0.5 rounded-full flex-shrink-0 whitespace-nowrap ${
                  item.tag === '爆' ? 'bg-primary-500 text-background-50' : 
                  item.tag === '热' ? 'bg-accent-500 text-background-50' : 
                  'bg-secondary-500 text-background-50'
                }`}>
                  {item.tag}
                </span>
              )}
              <span className="text-xs md:text-sm text-accent-600 font-medium flex-shrink-0 whitespace-nowrap">
                <i className="ri-fire-line text-accent-500 mr-0.5"></i>
                {item.heat}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}